import { ReactNode } from 'react';

export enum DialogueType {
  TRACKING_SUPPORT = 'tracking support',
  DELIVERY_NOTE = 'delivery note',
  COLLECTION_NOTE = 'collection note',
}

export interface DialogueCardData {
  analyticsId: string;
  type: DialogueType | string;
  title: string;
  content: ReactNode | JSX.Element;
  icon: ReactNode;
  actions?: ReactNode;
  customContent?: ReactNode | JSX.Element;
}
